var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.GetResponsiveClass,attrs:{"id":"login-header"}},[_c('span',{attrs:{"id":"title"}},[_vm._v("Plataforma de Servicios")])])
}
var staticRenderFns = []

export { render, staticRenderFns }